import Component from '../core/Component'
import ScrollService, {scrollToElement} from '../services/Scroll'
import { EVENTS } from '../core/Events'
import EventBus from '../core/EventBus'

export default class FooterAction extends Component {
    constructor(element) {
        super(element)
    }


    prepare() {
        this.element.addEventListener('click', this.handleLink)

        EventBus.on(EVENTS.SWUP_CONTENT_REPLACED, () => {
            this.element.addEventListener('click', this.handleLink)
        })
    }

    destroy() {
        this.element.removeEventListener('click', this.handleLink)
    }

    handleLink = (event) => {
        if(document.querySelector('.room-Page')) {
            scrollToElement(document.querySelector('#swup'))
        }
    }
}